import { IPaytable } from "./IPayTable";
import { IPayTableFactory, IPaytableParams } from "./IPayTableFactory";
import { IGroupedSimplePaytableData } from "./PayTable8Squares";
import { PayTable9Squares } from "./PayTable9Squares";
import { PayTable9SquaresPIXI } from "./PayTable9SquaresPIXI";

export class PaytableFactoryPIXIApp implements IPayTableFactory {

    CreatePayTable(paytableParams: IPaytableParams): IPaytable {

        // const paytableData = paytableParams.paytable as IGroupedSimplePaytableData;
        const Paytable = PaytableMap[paytableParams.paytable.Template](paytableParams);

        if (!Paytable) {
            throw new Error("Paytable type not found");
        }

        return Paytable;

    }

}

const PaytableMap: Record<string, (paytableParams: IPaytableParams) => IPaytable> = {
    "PayTable9Squares": (paytableParams: IPaytableParams) => new PayTable9SquaresPIXI(paytableParams),
}